import PropTypes from "prop-types";
import "./error-boundary.scss";

const RootErrorFallback = ({ error }) => {
    if (error) {
        console.error("[RootErrorFallback]", error);
    }

    return (
        <div className="root-error-fallback">
            <h1 className="root-error-fallback-title">Something went wrong</h1>
            <p className="root-error-fallback-subtitle">
                An unexpected error occurred. Please try reloading the page.
            </p>
            <button className="btn btn-primary" onClick={() => window.location.reload()}>
                Reload Page
            </button>
        </div>
    );
};

RootErrorFallback.propTypes = {
    error: PropTypes.object,
};

export default RootErrorFallback;
